import React from 'react';
import { useStoreState, observer } from 'base/store';
import DefaultLoading from '@base/common/DefaultLoading';
import { PageHeader, IPageHeaderProps } from '@app/common/PageHeader';
import { PageFooter } from '@app/common/PageFooter';
import { FixedContact } from '@app/common/FixedContact';
import { FixedCalendly } from '@pro/common/FixedCalendly';

type BaseLayoutProps = {
    loading?: boolean;
    header?: IPageHeaderProps;
}

const BaseLayout: Globals.FC<BaseLayoutProps> = props => {
    const {
        loading = false,
        header,
        children,
    } = props;

    const { pageLoading } = useStoreState('rootStore');

    return (
        <>
            <PageHeader {...header}/>

            {pageLoading || loading ? <DefaultLoading type="page"/> : children}

            <PageFooter/>

            <FixedContact/>
            
            <FixedCalendly />
        </>
    );
}

export default observer(BaseLayout);